//
import { ModuleLayout } from '@/components/reusable_components/next'
//import { OrdererCriticEdit } from '@/views/orderers'

//
import OrdererCreateView from '@/views/Warehouse/WhOrderer/create'
import OrdererListView from '@/views/Warehouse/WhOrderer/list'
import OrdererUpdateView from '@/views/Warehouse/WhOrderer/update'

//
export default {
    path: 'orderers',
    component: ModuleLayout,
    children: [
        {
            path: '',
            name: 'orderer',
            component: OrdererListView,
        },
        {
            path: 'create',
            name: 'orderer-create',
            component: OrdererCreateView,
            meta: {
                title: 'Crear solicitud de abastecimiento',
            },
        },
        {
            path: ':id',
            name: 'orderer-update',
            component: OrdererUpdateView,
            meta: {
                title: 'Datos de la solicitud de abastecimiento',
            },
        },
        /*{
            path: 'critical/:id',
            name: 'orderer-edit-critical',
            component: OrdererCriticEdit,
            meta: {
                title: 'Editar solicitud de abastecimiento con stock critico',
            },
        },*/
    ],
    meta: {
        title: 'Solicitudes de abastecimiento',
    },
}
